import apiClient from '@/services/apiClient';
import brand from '@/config/brand';

const STORAGE_KEY = `${brand.storagePrefix}_visitor_country`;
const STORAGE_CURRENCY_KEY = `${brand.storagePrefix}_display_currency`;

let geoInflight = null;

function readStoredGeo() {
  try {
    const country = localStorage.getItem(STORAGE_KEY);
    const displayCurrency = localStorage.getItem(STORAGE_CURRENCY_KEY);
    if (country && displayCurrency) {
      return {
        country_code: country,
        display_currency: displayCurrency,
        is_spain: country === 'ES',
      };
    }
  } catch {
    // ignore storage errors
  }
  return null;
}

function persistGeo(geo) {
  if (!geo?.country_code || !geo?.display_currency) return;
  try {
    localStorage.setItem(STORAGE_KEY, geo.country_code);
    localStorage.setItem(STORAGE_CURRENCY_KEY, geo.display_currency);
  } catch {
    // ignore storage errors
  }
}

function detectCountryFromBrowser() {
  const languages = [
    ...(navigator.languages || []),
    navigator.language,
  ].filter(Boolean);

  for (const lang of languages) {
    const normalized = String(lang).toUpperCase();
    if (normalized.endsWith('-ES') || normalized === 'ES') {
      return 'ES';
    }
  }

  try {
    if (Intl.DateTimeFormat().resolvedOptions().timeZone === 'Europe/Madrid') {
      return 'ES';
    }
  } catch {
    // ignore
  }

  return null;
}

function resolveDisplayCurrency() {
  return 'EUR';
}

export function getCachedGeo() {
  return readStoredGeo();
}

export async function loadVisitorGeo() {
  const cached = readStoredGeo();
  if (cached) return cached;

  if (geoInflight) return geoInflight;

  geoInflight = (async () => {
    try {
      const response = await apiClient.get('/geo/');
      const data = response.data || {};
      if (data.country_code && data.display_currency) {
        persistGeo(data);
        return data;
      }
    } catch {
      // fallback below
    }

    const browserCountry = detectCountryFromBrowser();
    const fallback = {
      country_code: browserCountry || 'INT',
      display_currency: resolveDisplayCurrency(),
      is_spain: browserCountry === 'ES',
    };
    persistGeo(fallback);
    return fallback;
  })().finally(() => {
    geoInflight = null;
  });

  return geoInflight;
}
